<template>
  <div class="cont">

    <div class="login-container">
      <div class="login-box">
        <h1>Reset Password</h1>

        <form @submit.prevent="handleSubmit" v-if="!done">
          <input type="password" placeholder="New password" v-model="password" required minlength="6" />
          <input type="password" placeholder="Confirm new password" v-model="confirmPassword" required minlength="6" />
          <button type="submit" :disabled="loading">{{ loading ? 'Resetting...' : 'Reset Password' }}</button>
        </form>

        <div v-else class="sent-message">
          <p>Your password has been reset. You can sign in now.</p>
        </div>

        <div class="signup">
          <p><router-link to="/login">Back to Sign In</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';

export default {
  name: 'ResetPasswordComponent',
  data() {
    return {
      password: '',
      confirmPassword: '',
      loading: false,
      done: false,
      toast: useToast(),
      prodUrl: process.env.VUE_APP_PROD_URL,
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'login' });
    },
    handleSubmit() {
      if (this.password !== this.confirmPassword) {
        this.toast.error('Passwords do not match');
        return;
      }

      this.loading = true;
      fetch(`${this.prodUrl}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.$route.params.token, password: this.password }),
      }).then(async (res) => {
        this.loading = false;
        res = await res.json();
        if (res.success) {
          this.done = true;
          setTimeout(() => this.$router.replace({ name: 'login' }), 2000);
        } else {
          this.toast.error(res.message || res.msg || 'Reset link is invalid or has expired.');
        }
      }).catch(() => {
        this.loading = false;
        this.toast.error('An error occurred. Please try again.');
      });
    },
  },
};
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  background: url('https://assets.nflxext.com/ffe/siteui/vlv3/6c6a5e8e-b88f-40c7-9dc2-2a2c0f4db2dc/fc5ffefb-7e42-4629-a0b1-8ebedb2ce2e8/IN-en-20230828-popsignuptwoweeks-perspective_alpha_website_large.jpg')
    center/cover no-repeat;
  display: flex;
  flex-direction: column;
  color: white;
  overflow-y: auto;
  scrollbar-width: none;
  display: grid;
  grid-template-rows: auto 1fr;
}

.login_heading {
  width: 100%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 1vh;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  padding: 0px 0vw;
  border-radius: 4px;
  width: 320px;
}

h1 {
  margin-bottom: 28px;
  font-weight: 600;
}

input {
  width: 100%;
  margin-bottom: 16px;
  padding: 14px;
  border: none;
  border-radius: 4px;
  background: #333;
  color: white;
  font-size: 14px;
}

input:focus {
  outline: 2px solid #e50914;
}

button {
  width: 100%;
  padding: 14px;
  background: #e50914;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  margin-top: 10px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background: #f6121d;
}

button:disabled {
  background: #7a0a0f;
  cursor: not-allowed;
}

.sent-message {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 1.6;
  background: #222;
  padding: 16px;
  border-radius: 4px;
}

.signup {
  margin-top: 30px;
  font-size: 14px;
  color: #b3b3b3;
}

.signup a {
  color: white;
  text-decoration: none;
}

.signup a:hover {
  text-decoration: underline;
}

@media (max-width: 675px) {
  .login-box {
    width: 90vw;
    max-width: 320px;
  }
}
</style>
